import { ContentHeader, PageHeaderLayout } from "@homebound/beam";

export function ProductOfferingsOptionsPage() {
  return (
    <PageHeaderLayout pageHeader={{ title: "Options" }}>
      <ContentHeader description="Manage which options are available in Checkout and Underwriting across all plans in this community. All conflicts and dependencies are already attached." />
    </PageHeaderLayout>
  );
}
